module.exports = __webpack_public_path__ + "media/logo/it_management_logo-07744cb2.png";